import axios from '../api/axiosInstance';

export const fetchDashboardSummary = ({ startDate, endDate } = {}) => {
  const params = {};

  if (startDate) {
    params.startDate = startDate;
  }

  if (endDate) {
    params.endDate = endDate;
  }

  return axios.get('/dashboard/summary', { params });
};

export default {
  fetchDashboardSummary,
};
